module.exports = __webpack_public_path__ + "img/mediana-logo-small-white.795fdf0b.svg";